import { APP_URLS } from "config/urls"

export type MenuItem = {
  id: number
  title: string
  slug: string
  url: string
  showNotification?: boolean
}

type FlaggedMenuItem = {
  item: MenuItem
  flag?: boolean
}

type Flags = {
  showMemberBenefits?: boolean
  showOrderItAgain?: boolean
  showForYou?: boolean
}

export type MenuOptions = {
  isMember: boolean
  flags?: Flags
}

// This function is used to filter out menu items that have a flag set to false
// True or undefined will allow it to be shown (covering SSR components)
export const filterMenuItems = (items: FlaggedMenuItem[]): MenuItem[] => {
  return items.filter(({ flag = true }) => flag).map(({ item }) => item)
}

const menuItems: MenuItem[] = [
  {
    id: 1,
    title: "Order History",
    slug: "order-history",
    url: APP_URLS.orderHistory,
  },
  {
    id: 4,
    title: "Wishlist",
    slug: "wishlist",
    url: APP_URLS.wishlist,
  },
  {
    id: 5,
    title: "Membership & Billing",
    slug: "membership-billing",
    url: APP_URLS.myMembership,
  },
  {
    id: 6,
    title: "Address Book",
    slug: "address-book",
    url: APP_URLS.addressBook,
  },
  {
    id: 7,
    title: "Profile",
    slug: "profile",
    url: APP_URLS.profile,
  },
]

const memberAccountItems = ({ showMemberBenefits, showForYou }: Flags) =>
  filterMenuItems([
    {
      item: {
        id: 8,
        title: "Refer a Friend",
        slug: "refer-a-friend",
        url: APP_URLS.referAFriend,
      },
    },
    {
      item: {
        id: 9,
        title: "Member Perks",
        slug: "member-benefits",
        url: APP_URLS.memberBenefits,
      },
      flag: showMemberBenefits,
    },

    {
      item: {
        id: 2,
        title: "Order It Again",
        slug: "order-it-again",
        url: APP_URLS.orderItAgain,
      },
      flag: !showForYou,
    },
    {
      item: {
        id: 3,
        title: "Your Favourites",
        slug: "your-favourites",
        url: APP_URLS.forYou,
      },
      flag: showForYou,
    },
  ])

const memberMenuItems = ({ showForYou, showMemberBenefits }: Flags) =>
  filterMenuItems([
    {
      item: {
        id: 8,
        title: "Refer a Friend",
        slug: "refer-a-friend",
        url: APP_URLS.referAFriend,
      },
    },
    {
      item: {
        id: 9,
        title: "Member Perks",
        slug: "member-benefits",
        url: APP_URLS.memberBenefits,
      },
      flag: showMemberBenefits,
    },
    {
      item: {
        id: 2,
        title: "Order It Again",
        slug: "order-it-again",
        url: APP_URLS.orderItAgain,
        showNotification: true,
      },
    },
    {
      item: {
        id: 3,
        title: "Just For You",
        slug: "just-for-you",
        url: APP_URLS.forYou,
      },
      flag: showForYou,
    },
  ])

export const getAccountItems = ({
  flags = {},
  isMember,
}: MenuOptions): MenuItem[] => {
  const memberOnlyItems = isMember ? memberAccountItems(flags) : []

  const menu: MenuItem[] = [...menuItems, ...memberOnlyItems].filter(Boolean)

  return menu.sort((a, b) => a.id - b.id)
}

export const getUserMenuItems = ({
  flags = {},
  isMember,
}: MenuOptions): MenuItem[] => {
  const memberOnlyItems = isMember ? memberMenuItems(flags) : []

  const menu: MenuItem[] = [...menuItems, ...memberOnlyItems].filter(Boolean)

  return menu.sort((a, b) => a.id - b.id)
}
